import type { Key } from 'react';
import { useCallback } from 'react';
import { useAtom } from 'jotai';
import { useSidePanel } from '../../../side-panel/side-panel-provider';
type PropsT = {
  annotationIds: string[];
};
type ResultT = {
  expandedKeys: Key[];
  onIconClick: (id: Key) => void;
  onNameClick: (id: Key) => void;
};
export const useAnnotationExpansion = ({
  annotationIds
}: PropsT): ResultT => {
  const {
    expandedAnnotationIdsAtom
  } = useSidePanel();
  const [expandedAnnotationIds, setExpandedAnnotationIds] = useAtom(expandedAnnotationIdsAtom);
  const onIconClick = useCallback((id: Key) => {
    setExpandedAnnotationIds(prev => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  }, [setExpandedAnnotationIds]);
  const onNameClick = useCallback((id: Key) => {
    setExpandedAnnotationIds(prev => {
      const next = new Set(prev);
      next.add(id);
      return next;
    });
  }, [setExpandedAnnotationIds]);
  const annotationIdSet = new Set(annotationIds);
  const filteredExpanded = Array.from(expandedAnnotationIds).filter(id => annotationIdSet.has((id as string)));
  return {
    expandedKeys: filteredExpanded,
    onIconClick,
    onNameClick
  };
};